import { JsonLd } from '@/components/feature/JsonLd';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '17c.cn',
  url: 'https://17c.cn',
  description: '17c.cn 是您信赖的网络平台官方入口，提供快速、安全、便捷的一站式服务体验。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@17c.cn',
    contactType: 'customer service',
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressCountry: 'CN',
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '17c.cn',
  url: 'https://17c.cn',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://17c.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function GlobalSchema() {
  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
    </>
  );
}